export default __webpack_public_path__ + "static/media/30.24ff82c7.png";